import { FC } from 'react'

import * as S from './styled'
import { ArrowRightIcon, ExclusivePlatformShape } from '../../icons'

const ExclusivePlatform: FC = () => (
  <S.Container>
    <S.Wrapper>
      <S.Bg>
        <ExclusivePlatformShape />
      </S.Bg>

      <S.Content>
        <S.Title>
          <span>06</span> Acesso à plataforma exclusiva
        </S.Title>

        <S.InfoContainer>
          <p>
            Os Participantes poderão acessar a plataforma exclusiva do Programa
            de Fidelidade por meio de link disponibilizado pela LEROY MERLIN nas
            lojas físicas, bem como na página principal do site e aplicativo da
            LEROY MERLIN, e com o uso das mesmas credenciais criadas para a
            Conta de Acesso.
          </p>

          <S.InfoMore>
            <ArrowRightIcon />

            <p>
              A plataforma exclusiva deve ser considerada, para todos os fins,
              uma seção do Site e Aplicativo. Aplicam-se a ela todas as
              ressalvas previstas nas seções de Garantias e Responsabilidades
              abaixo.
            </p>
          </S.InfoMore>
        </S.InfoContainer>
      </S.Content>
    </S.Wrapper>
  </S.Container>
)

export default ExclusivePlatform
